/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import UiFormLabel from './UiFormLabel'

export interface UiTextareaProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: React.ReactNode
    error?: string
    hasError?: boolean
    containerClassName?: string
}

const UiTextarea = React.forwardRef<HTMLTextAreaElement, UiTextareaProps>(
    (
        {
            label,
            error,
            hasError,
            containerClassName,
            className,
            disabled,
            ...props
        },
        ref
    ) => {
        return (
            <div className={clsx('UiTextarea flex flex-col gap-1.5', containerClassName)}>
                {label && (
                    <UiFormLabel isRequired={props.required}>
                        {label}
                    </UiFormLabel>
                )}
                <textarea
                    ref={ref}
                    className={clsx(
                        'flex min-h-20 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-500 focus-visible:outline-none focus-visible:border-blue-500 focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-800 dark:bg-gray-950 dark:placeholder:text-gray-400 dark:focus-visible:border-blue-400',
                        error || hasError
                            ? 'border-red-500 focus-visible:border-blue-500'
                            : '',
                        className
                    )}
                    disabled={disabled}
                    {...props}
                />
                {error && <span className="text-xs text-red-500">{error}</span>}
            </div>
        )
    }
)

UiTextarea.displayName = 'UiTextarea'

export default UiTextarea
